import StockPreview from "./StockPreview";

export {StockPreview}
export default StockPreview
